// extracted by mini-css-extract-plugin
export default {"viewCount":"ViewCount_viewCount__jiPCh","icon":"ViewCount_icon__+Ni6t","label":"ViewCount_label__VAPLD"};